import {
  BOM_TEMPLATE_ALL,
  BOM_TEMPLATE_GET,
  BOM_TEMPLATE_DELETE,
  BOM_TEMPLATE_PUT,
  BOM_TEMPLATE_POST,
  BOM_TEMPLATE_LOADING,
  BOM_TEMPLATE_ERROR,
} from '../types';

import api from '../../../configs/api';
import graphqlClient from '../../../configs/graphqlClient';

export const bomTemplateCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: BOM_TEMPLATE_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/bom-template`,
      {
        ...payload,
      },
    );
    dispatch({ type: BOM_TEMPLATE_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: BOM_TEMPLATE_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const bomTemplateAll = ({ name = '', size = 10, page = 1 }) => async (
  dispatch,
) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/bom-template?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: BOM_TEMPLATE_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: BOM_TEMPLATE_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const bomTemplateAllQuery = ({ query }) => async (dispatch) => {
  try {
    const queryResult = await graphqlClient.request(query);
    const data = queryResult?.findUnits;
    //  console.log('Query Data', queryResult);
    if (!data) {
      dispatch({ type: BOM_TEMPLATE_ERROR });
    }

    dispatch({ type: BOM_TEMPLATE_ALL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: BOM_TEMPLATE_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const bomTemplateGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/bom-template/${id}`,
    );
    if (status === 200) {
      dispatch({ type: BOM_TEMPLATE_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: BOM_TEMPLATE_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const bomTemplateStateSet = (data) => async (dispatch) => {
  dispatch({ type: BOM_TEMPLATE_ALL, payload: data });
};

export const bomTemplateStateOneSet = (data) => async (dispatch) => {
  dispatch({ type: BOM_TEMPLATE_GET, payload: data });
};

export const bomTemplateReset = () => async (dispatch) => {
  dispatch({ type: BOM_TEMPLATE_LOADING });
};

export const bomTemplateError = () => async (dispatch) => {
  dispatch({ type: BOM_TEMPLATE_ERROR });
};

export const bomTemplatePut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: BOM_TEMPLATE_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/bom-template/${id}`,
      payload,
    );
    dispatch({ type: BOM_TEMPLATE_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: BOM_TEMPLATE_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};
export const bomTemplateDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: BOM_TEMPLATE_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/bom-template/${id}`,
    );
    dispatch({ type: BOM_TEMPLATE_DELETE, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: BOM_TEMPLATE_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};
